// Service data for all service pages
export const servicesData = {
  'end-of-lease-cleaning-point-cook': {
    title: 'End of Lease Cleaning Point Cook',
    h1: 'End of Lease Cleaning in Point Cook - 100% Bond Back Guarantee',
    subtitle: 'Professional End of Tenancy Cleaning Services | Get Your Full Bond Back',
    metaDescription: 'End of lease cleaning Point Cook with 100% bond back guarantee. Professional exit cleaning services across Melbourne Western suburbs. Book same-day cleaning. Call +61 493 519 401',
    heroImage: '/img/service/end-of-lease.jpg',
    whyChooseTitle: 'Why Choose Niks Elite Cleaning for End of Lease Cleaning?',
    whyChooseContent: (
      <>
        <p>Moving out? Don't risk losing your bond! Niks Elite Cleaning specializes in end of lease cleaning in Point Cook and surrounding Melbourne suburbs. Our professional team has helped over 1,500 tenants get their full bond back with our meticulous cleaning service.</p>
        <p>We understand the strict requirements of real estate agents and property managers in Point Cook, Werribee, Truganina, and across Melbourne's western suburbs. Our comprehensive checklist covers every inch of your property, ensuring it meets - and exceeds - inspection standards.</p>
        <p>With over 5 years of experience in the Point Cook area, we know exactly what landlords and agents expect. Our eco-friendly cleaning products are tough on dirt but gentle on surfaces, and our professional-grade equipment ensures a deep, thorough clean every time.</p>
        <p>We offer flexible scheduling including same-day service, weekends, and after-hours appointments to fit your moving timeline. All our cleaners are fully insured, police-checked, and trained to the highest standards.</p>
      </>
    ),
    includedTitle: "What's Included in Our End of Lease Cleaning",
    includedItems: [
      'Complete kitchen deep clean including oven, rangehood, and appliances',
      'Bathroom sanitization with tile and grout scrubbing',
      'All windows cleaned inside (exterior optional)',
      'Skirting boards, doors, and light switches wiped down',
      'Carpet steam cleaning (additional service)',
      'Cobweb removal from all corners and ceilings',
      'Cupboards, wardrobes, and drawers cleaned inside and out',
      'Floor mopping and vacuuming throughout',
      'Wall mark removal and spot cleaning',
      'Balcony/patio cleaning (if applicable)',
      'Exhaust fans and air vents cleaned',
      'Light fixtures and ceiling fans dusted'
    ],
    guarantee: {
      title: '100% Bond Back Guarantee',
      content: (
        <>
          <p><strong>We stand behind our work with a 100% bond back guarantee.</strong></p>
          <p>If your property manager or landlord identifies any cleaning issues during inspection (within 72 hours of our service), we'll return to re-clean those areas at no extra charge. This guarantee is subject to normal wear and tear and assumes the property was in reasonable condition before cleaning.</p>
          <p>Our team follows a comprehensive 50-point checklist that covers all areas typically inspected during bond returns in Victoria. We've achieved a 98% first-time bond return rate for our clients across Point Cook, Werribee, and Melbourne.</p>
        </>
      )
    },
    areasContent: 'We proudly provide end of lease cleaning services throughout Melbourne\'s western suburbs. Our local team knows the specific requirements of property managers in each area:',
    serviceAreas: [
      'Point Cook VIC 3030',
      'Werribee VIC 3030',
      'Truganina VIC 3029',
      'Hoppers Crossing VIC 3029',
      'Williams Landing VIC 3027',
      'Sunshine VIC 3020',
      'Melbourne VIC 3004',
      'Parkville VIC 3052'
    ],
    faqs: [
      {
        question: 'How long does end of lease cleaning take?',
        answer: 'Typically 3-6 hours for a standard 2-3 bedroom property, depending on size and condition. Larger homes or properties requiring extra attention may take longer. We\'ll provide an accurate timeframe during your quote.'
      },
      {
        question: 'Do I need to be present during the clean?',
        answer: 'No, you don\'t need to be present. Most clients provide access via lockbox or arrange key pickup. We\'ll notify you once the clean is complete and can send photos if requested.'
      },
      {
        question: 'What if my agent finds something after your clean?',
        answer: 'Under our 100% bond back guarantee, we\'ll return within 72 hours to re-clean any areas that don\'t meet inspection standards at no additional cost.'
      },
      {
        question: 'Do you provide carpet steam cleaning?',
        answer: 'Yes! Carpet steam cleaning can be added to your end of lease package. Many property managers in Point Cook require professional carpet cleaning receipts for bond returns.'
      },
      {
        question: 'How much does end of lease cleaning cost in Point Cook?',
        answer: 'Prices vary based on property size and condition. Contact us for a free, no-obligation quote. We offer transparent, fixed-price quotes with no hidden fees.'
      },
      {
        question: 'Can you clean the same day I move out?',
        answer: 'Subject to availability, yes! We offer same-day service across Point Cook and Melbourne western suburbs. Call us as early as possible to check availability.'
      }
    ]
  },

  'carpet-cleaning-melbourne': {
    title: 'Carpet Cleaning Melbourne',
    h1: 'Professional Carpet Cleaning Services Melbourne & Western Suburbs',
    subtitle: 'Steam Cleaning & Stain Removal | Eco-Friendly Products | Same-Day Service Available',
    metaDescription: 'Professional carpet cleaning Melbourne using hot water extraction steam cleaning. Remove stains, odors, allergens. Servicing Point Cook, Werribee, Sunshine. Book now +61 493 519 401',
    heroImage: '/img/service/carpet-cleaning.jpg',
    whyChooseTitle: 'Expert Carpet Steam Cleaning Across Melbourne',
    whyChooseContent: (
      <>
        <p>Transform your carpets with Niks Elite Cleaning's professional steam cleaning service. Serving Point Cook, Werribee, Sunshine, and all Melbourne western suburbs, we use industrial-grade hot water extraction equipment to deep clean your carpets, removing embedded dirt, stains, allergens, and odors.</p>
        <p>Unlike regular vacuuming which only cleans the surface, our carpet steam cleaning penetrates deep into carpet fibers, extracting dirt, dust mites, bacteria, and allergens that accumulate over time. This not only improves the appearance of your carpets but also creates a healthier indoor environment for your family.</p>
        <p>Our team uses eco-friendly, non-toxic cleaning solutions that are safe for children and pets while being highly effective at breaking down tough stains and odors. We treat each carpet type appropriately - from delicate wool to synthetic fibers - ensuring optimal results without damage.</p>
        <p>Whether you need residential carpet cleaning for your home or commercial carpet cleaning for your office, our experienced technicians deliver exceptional results every time. We service all suburbs across Melbourne's west including Truganina, Hoppers Crossing, Williams Landing, and Parkville.</p>
      </>
    ),
    includedTitle: 'Our Carpet Cleaning Process',
    includedItems: [
      'Pre-inspection and carpet assessment',
      'Pre-vacuum to remove loose dirt and debris',
      'Pre-treatment of heavy stains and high-traffic areas',
      'Hot water extraction (steam) cleaning',
      'Spot treatment for stubborn stains',
      'Deodorizing treatment (optional)',
      'Post-cleaning inspection',
      'Fast-drying technique (4-6 hours)',
      'Furniture moving (if required)',
      'Carpet protection application (optional add-on)',
      'Pet stain and odor removal',
      'Traffic lane recovery for worn areas'
    ],
    guarantee: {
      title: 'Satisfaction Guaranteed',
      content: (
        <>
          <p><strong>We guarantee you'll love the results or we'll re-clean for free.</strong></p>
          <p>Our carpet cleaning service comes with a 7-day satisfaction guarantee. If you're not completely happy with the results, we'll return to address any concerns at no extra charge. We use professional-grade equipment and proven techniques to ensure your carpets look and smell fresh.</p>
          <p>Most carpets are dry and ready to walk on within 4-6 hours thanks to our powerful extraction equipment. We also offer stain protection treatments to help keep your carpets cleaner for longer.</p>
        </>
      )
    },
    areasContent: 'Our mobile carpet cleaning service covers all Melbourne western suburbs with same-day availability in most areas:',
    serviceAreas: [
      'Point Cook VIC 3030',
      'Werribee VIC 3030',
      'Sunshine VIC 3020',
      'Truganina VIC 3029',
      'Hoppers Crossing VIC 3029',
      'Williams Landing VIC 3027',
      'Melbourne VIC 3004',
      'Parkville VIC 3052'
    ],
    faqs: [
      {
        question: 'How long do carpets take to dry after steam cleaning?',
        answer: 'Typically 4-6 hours with our powerful extraction equipment. Drying time can vary based on carpet thickness, humidity, and air circulation. We recommend opening windows and using fans to speed up drying.'
      },
      {
        question: 'Can you remove pet stains and odors?',
        answer: 'Yes! We specialize in pet stain and odor removal using enzyme-based treatments that break down organic matter. For best results, fresh stains should be treated as soon as possible.'
      },
      {
        question: 'Is steam cleaning safe for all carpet types?',
        answer: 'Steam cleaning is safe for most carpets including wool, nylon, polyester, and blended fibers. We assess your carpet type during pre-inspection and adjust our method accordingly. Delicate materials may require alternative cleaning methods.'
      },
      {
        question: 'How often should carpets be professionally cleaned?',
        answer: 'We recommend professional steam cleaning every 6-12 months for residential carpets, or more frequently for high-traffic areas, homes with pets, or allergy sufferers. Commercial carpets may need quarterly cleaning.'
      },
      {
        question: 'Do you move furniture?',
        answer: 'Yes, we move light furniture as part of our service. Heavy items like beds, dressers, and entertainment centers should be moved prior to our arrival, or we can arrange this for an additional fee.'
      }
    ]
  },

  'domestic-cleaning-sunshine': {
    title: 'Domestic Cleaning Sunshine',
    h1: 'Domestic Cleaning Services in Sunshine & Melbourne Western Suburbs',
    subtitle: 'Regular House Cleaning | Deep Cleaning | Flexible Scheduling',
    metaDescription: 'Professional domestic cleaning services in Sunshine VIC. Weekly, fortnightly, or one-off house cleaning. Eco-friendly products. Trusted cleaners. Call +61 493 519 401',
    heroImage: '/img/service/domestic-cleaning.jpg',
    whyChooseTitle: 'Your Trusted Domestic Cleaners in Sunshine',
    whyChooseContent: (
      <>
        <p>Life is busy enough without worrying about housework. Niks Elite Cleaning provides professional domestic cleaning services in Sunshine, Point Cook, Werribee, and across Melbourne's western suburbs. Let us handle the cleaning while you focus on what matters most to you.</p>
        <p>Our domestic cleaning service is fully customizable to your needs. Whether you need weekly maintenance cleaning, a fortnightly deep clean, or a one-off spring clean, we create a cleaning plan that suits your lifestyle and budget. Our experienced cleaners bring their own eco-friendly supplies and professional equipment.</p>
        <p>We understand that inviting someone into your home requires trust. That's why all our cleaners are police-checked, fully insured, and trained to our high standards. Many of our Sunshine clients have been with us for years, trusting us with their house keys and enjoying coming home to a spotlessly clean house.</p>
        <p>From basic maintenance cleaning to deep cleaning services, we handle everything from kitchen and bathroom sanitization to dusting, vacuuming, and mopping throughout your home. We're flexible with scheduling and can work around your routine, including weekends and after-hours appointments.</p>
      </>
    ),
    includedTitle: 'What\'s Included in Our Domestic Cleaning Service',
    includedItems: [
      'Kitchen cleaning including bench tops, sink, and appliances',
      'Bathroom sanitization and scrubbing',
      'Dusting all surfaces, furniture, and fixtures',
      'Vacuuming all floors and carpets',
      'Mopping hard floors',
      'Bed making and linen changing (optional)',
      'Internal window cleaning',
      'Skirting board wiping',
      'Emptying bins and replacing liners',
      'Dishwashing and putting away (optional)',
      'Refrigerator cleaning (deep clean service)',
      'Oven cleaning (deep clean service)'
    ],
    guarantee: null,
    areasContent: 'We provide reliable domestic cleaning services throughout Melbourne\'s western suburbs:',
    serviceAreas: [
      'Sunshine VIC 3020',
      'Point Cook VIC 3030',
      'Werribee VIC 3030',
      'Truganina VIC 3029',
      'Hoppers Crossing VIC 3029',
      'Williams Landing VIC 3027',
      'Melbourne VIC 3004',
      'Parkville VIC 3052'
    ],
    faqs: [
      {
        question: 'What\'s the difference between regular and deep cleaning?',
        answer: 'Regular cleaning covers surface cleaning, vacuuming, mopping, and bathroom/kitchen maintenance. Deep cleaning includes everything in regular cleaning plus detailed work like oven cleaning, inside fridges, window tracks, skirting boards, and areas not typically covered in weekly cleans.'
      },
      {
        question: 'Do I need to provide cleaning supplies?',
        answer: 'No, we bring all necessary cleaning products and equipment. We use eco-friendly, non-toxic products safe for families and pets. If you have specific product preferences, we\'re happy to use your supplies.'
      },
      {
        question: 'Can I have the same cleaner each visit?',
        answer: 'Yes! For regular clients, we assign the same cleaner or team to your home each visit. This builds trust and ensures consistency as your cleaner becomes familiar with your home and preferences.'
      },
      {
        question: 'How much does domestic cleaning cost in Sunshine?',
        answer: 'Pricing depends on home size, cleaning frequency, and service type. We offer competitive rates with discounts for regular weekly or fortnightly service. Contact us for a free, personalized quote.'
      },
      {
        question: 'What if I need to cancel or reschedule?',
        answer: 'We understand plans change. For regular clients, we request 24 hours notice for cancellations or rescheduling. We\'re flexible and work with you to find alternative times that suit.'
      }
    ]
  },

  'commercial-cleaning-werribee': {
    title: 'Commercial Cleaning Werribee',
    h1: 'Commercial Cleaning Services Werribee & Melbourne',
    subtitle: 'Office Cleaning | Retail Cleaning | Medical & Hospitality Cleaning',
    metaDescription: 'Professional commercial cleaning Werribee and Melbourne. Office cleaning, retail, medical facilities. Daily, weekly, or customized schedules. Call +61 493 519 401',
    heroImage: '/img/service/commercial-cleaning.jpg',
    whyChooseTitle: 'Professional Commercial Cleaning for Werribee Businesses',
    whyChooseContent: (
      <>
        <p>First impressions matter in business. A clean, well-maintained workspace not only impresses clients and customers but also boosts employee morale and productivity. Niks Elite Cleaning provides professional commercial cleaning services to businesses across Werribee, Point Cook, and Melbourne's western suburbs.</p>
        <p>We understand that every business has unique cleaning needs. Whether you run an office, retail store, medical facility, or hospitality venue, we create customized cleaning programs that fit your schedule and budget. Our flexible service options include daily, weekly, or monthly cleaning, with after-hours and weekend service available.</p>
        <p>Our commercial cleaning team is experienced, reliable, and fully insured. All cleaners undergo thorough background checks and are trained in commercial cleaning best practices, workplace safety, and COVID-19 sanitization protocols. We use commercial-grade equipment and products to ensure superior results.</p>
        <p>From small offices to large commercial complexes, we maintain consistent quality and attention to detail. We're committed to using eco-friendly cleaning products wherever possible, creating a healthier environment for your staff and clients while minimizing environmental impact.</p>
      </>
    ),
    includedTitle: 'Our Commercial Cleaning Services',
    includedItems: [
      'Office cleaning and sanitization',
      'Bathroom deep cleaning and restocking',
      'Kitchen and break room cleaning',
      'Vacuuming and carpet care',
      'Hard floor mopping and buffing',
      'Dusting desks, surfaces, and equipment',
      'Window and glass cleaning',
      'Trash removal and recycling',
      'High-touch point sanitization',
      'Reception area maintenance',
      'Meeting room setup and cleaning',
      'Warehouse and storage area cleaning'
    ],
    guarantee: {
      title: 'Quality Assurance & Accountability',
      content: (
        <>
          <p><strong>We maintain the highest standards through regular quality checks and responsive service.</strong></p>
          <p>Every commercial client is assigned a dedicated account manager who conducts regular site inspections to ensure our service meets your expectations. We use digital checklists and reporting to maintain accountability and transparency.</p>
          <p>If you're ever unsatisfied with our service, we'll address concerns immediately - usually within 24 hours. Our goal is to build long-term partnerships with Werribee businesses by delivering consistent, reliable cleaning services.</p>
        </>
      )
    },
    areasContent: 'We service commercial properties throughout Melbourne\'s western business districts:',
    serviceAreas: [
      'Werribee VIC 3030',
      'Point Cook VIC 3030',
      'Hoppers Crossing VIC 3029',
      'Truganina VIC 3029',
      'Williams Landing VIC 3027',
      'Sunshine VIC 3020',
      'Melbourne CBD VIC 3004',
      'Parkville VIC 3052'
    ],
    faqs: [
      {
        question: 'What types of businesses do you clean?',
        answer: 'We clean all types of commercial properties including offices, retail stores, medical clinics, gyms, schools, warehouses, and hospitality venues. Each business type has specific cleaning requirements which we address in our customized cleaning plans.'
      },
      {
        question: 'Can you clean outside business hours?',
        answer: 'Yes! Most of our commercial cleaning is done after hours, early mornings, or weekends to avoid disrupting your business operations. We\'re flexible and work around your schedule.'
      },
      {
        question: 'Do you provide COVID-19 sanitization?',
        answer: 'Absolutely. We follow all health guidelines for commercial cleaning including high-touch point sanitization, proper disinfection protocols, and can provide additional deep sanitization services as needed.'
      },
      {
        question: 'How do you ensure consistent quality?',
        answer: 'We use detailed cleaning checklists, conduct regular quality inspections, assign dedicated teams to each property, and provide ongoing training to our staff. You\'ll also have a direct point of contact for any concerns.'
      },
      {
        question: 'What\'s included in your commercial cleaning contract?',
        answer: 'We create customized contracts based on your specific needs. Typical contracts include detailed scope of work, service frequency, pricing, quality standards, and terms. We can arrange short-term trials before long-term commitments.'
      }
    ]
  },

  'office-cleaning-melbourne': {
    title: 'Office Cleaning Melbourne',
    h1: 'Office Cleaning Services Melbourne & Western Suburbs',
    subtitle: 'Daily Office Cleaning | COVID-Safe Practices | After-Hours Service',
    metaDescription: 'Professional office cleaning Melbourne. Daily, weekly cleaning services for offices in Point Cook, Werribee, Sunshine. After-hours available. Call +61 493 519 401',
    heroImage: '/img/service/office-cleaning.jpg',
    whyChooseTitle: 'Melbourne\'s Trusted Office Cleaning Service',
    whyChooseContent: (
      <>
        <p>A clean office is a productive office. Niks Elite Cleaning specializes in office cleaning services across Melbourne, Point Cook, Werribee, and western suburbs. We understand that your office is your business's face - let us keep it looking professional, welcoming, and hygienic.</p>
        <p>Our office cleaning service goes beyond basic tidying. We provide comprehensive cleaning that creates a healthier workplace, reduces sick days, and impresses clients the moment they walk through your door. From daily maintenance to deep cleaning projects, we handle it all with professionalism and attention to detail.</p>
        <p>We work with businesses of all sizes - from small startups to large corporate offices. Our team is experienced in modern office environments including open-plan offices, hot-desking setups, meeting rooms, and collaborative spaces. We understand the importance of minimal disruption, which is why most of our office cleaning is performed after hours or early mornings.</p>
        <p>All our office cleaners are police-checked, fully insured, and trained in COVID-safe cleaning practices. We use commercial-grade, eco-friendly products that effectively clean and sanitize without harsh chemical odors, ensuring your office is fresh and ready for business each day.</p>
      </>
    ),
    includedTitle: 'Comprehensive Office Cleaning Checklist',
    includedItems: [
      'Workstation dusting and sanitization',
      'Keyboard, mouse, and phone cleaning',
      'Emptying and sanitizing trash bins',
      'Vacuuming all carpeted areas',
      'Mopping hard floors and tiles',
      'Bathroom deep cleaning and restocking',
      'Kitchen and break room sanitization',
      'Glass and window cleaning',
      'Reception area maintenance',
      'Meeting room preparation',
      'High-touch surface disinfection',
      'Printer and equipment area cleaning'
    ],
    guarantee: {
      title: 'Reliable & Consistent Service',
      content: (
        <>
          <p><strong>Your office deserves consistent, reliable cleaning every single time.</strong></p>
          <p>We assign dedicated cleaning teams to your office so you get familiar faces who understand your space and preferences. Our supervisors conduct regular site visits to ensure quality standards are maintained. You'll have a direct point of contact for any requests or concerns.</p>
          <p>We track our service using digital checklists and can provide cleaning reports upon request. If you're ever unsatisfied, we'll address issues within 24 hours - most concerns are resolved same-day.</p>
        </>
      )
    },
    areasContent: 'Servicing office buildings and business parks throughout Melbourne\'s western suburbs:',
    serviceAreas: [
      'Melbourne CBD VIC 3004',
      'Point Cook VIC 3030',
      'Werribee VIC 3030',
      'Sunshine VIC 3020',
      'Parkville VIC 3052',
      'Truganina VIC 3029',
      'Hoppers Crossing VIC 3029',
      'Williams Landing VIC 3027'
    ],
    faqs: [
      {
        question: 'When do you clean offices?',
        answer: 'We typically clean offices after business hours (evenings) or early mornings before staff arrive. This minimizes disruption to your workday. We can also arrange daytime cleaning for businesses with flexible arrangements.'
      },
      {
        question: 'How often should an office be cleaned?',
        answer: 'Most offices benefit from daily or 3-5 times per week cleaning, depending on office size and staff numbers. Smaller offices might need weekly or fortnightly service. We\'ll recommend a schedule based on your specific needs.'
      },
      {
        question: 'Do you provide supplies or do we?',
        answer: 'We provide all cleaning products, equipment, and consumables (trash liners, etc.) as part of our service. For bathroom restocking (toilet paper, hand soap, paper towels), we can either supply these or use your existing stock - whichever you prefer.'
      },
      {
        question: 'Are your cleaners security-checked?',
        answer: 'Yes, all our office cleaners undergo police background checks and are fully insured. We understand the trust required when providing access to your business premises and take security very seriously.'
      },
      {
        question: 'Can you handle specialized cleaning needs?',
        answer: 'Yes! Whether you need high-level dusting, specialized floor care, IT equipment cleaning, or deep sanitization, we can accommodate most specialized requests either as part of regular service or as add-ons.'
      }
    ]
  },

  'window-cleaning-truganina': {
    title: 'Window Cleaning Truganina',
    h1: 'Professional Window Cleaning Services Truganina & Melbourne',
    subtitle: 'Residential & Commercial Window Cleaning | Streak-Free Results',
    metaDescription: 'Professional window cleaning Truganina, Point Cook, Melbourne western suburbs. Residential and commercial. Streak-free guarantee. Call +61 493 519 401',
    heroImage: '/img/service/window-cleaning.jpg',
    whyChooseTitle: 'Crystal Clear Window Cleaning in Truganina',
    whyChooseContent: (
      <>
        <p>Let the sunshine in with professional window cleaning from Niks Elite Cleaning. Serving Truganina, Point Cook, Werribee, and all Melbourne western suburbs, we make your windows sparkle with our streak-free cleaning service for both residential and commercial properties.</p>
        <p>Clean windows dramatically improve your home or business's appearance, increase natural light, and protect your windows from damage caused by built-up dirt and grime. Our professional window cleaning service uses purified water technology and specialized equipment to deliver crystal-clear results that last longer than traditional methods.</p>
        <p>We clean all types of windows including standard residential windows, multi-story commercial buildings, hard-to-reach windows, skylights, and glass doors. Our team is trained in safe work practices and uses appropriate equipment including extension poles, ladders, and safety harnesses for elevated work.</p>
        <p>Whether you need a one-off window clean for spring cleaning, regular maintenance window cleaning, or post-construction window cleaning, we deliver professional results every time. We service residential homes, offices, retail stores, and commercial buildings throughout Truganina and Melbourne's western region.</p>
      </>
    ),
    includedTitle: 'Our Window Cleaning Service Includes',
    includedItems: [
      'Internal and external window cleaning',
      'Window frame and sill cleaning',
      'Fly screen removal and cleaning',
      'Glass door cleaning',
      'Skylight cleaning',
      'Window track vacuuming',
      'Streak-free purified water cleaning',
      'Spot-free finish guaranteed',
      'Hard water stain removal',
      'Paint and debris removal',
      'High-access window cleaning',
      'Mirror cleaning'
    ],
    guarantee: {
      title: 'Streak-Free Guarantee',
      content: (
        <>
          <p><strong>We guarantee perfectly clean, streak-free windows or we'll re-clean them for free.</strong></p>
          <p>Using purified water technology and professional squeegee techniques, we achieve crystal-clear results without streaks, spots, or residue. Our window cleaning lasts longer because purified water doesn't leave mineral deposits that attract dirt.</p>
          <p>If you notice any streaks or spots within 48 hours of our service, we'll return to touch up those windows at no charge. Your satisfaction is our priority.</p>
        </>
      )
    },
    areasContent: 'We provide window cleaning services throughout Melbourne\'s western suburbs:',
    serviceAreas: [
      'Truganina VIC 3029',
      'Point Cook VIC 3030',
      'Werribee VIC 3030',
      'Hoppers Crossing VIC 3029',
      'Williams Landing VIC 3027',
      'Sunshine VIC 3020',
      'Melbourne VIC 3004',
      'Parkville VIC 3052'
    ],
    faqs: [
      {
        question: 'How often should windows be professionally cleaned?',
        answer: 'For residential properties, we recommend professional window cleaning 2-4 times per year (every season or every 6 months). Commercial properties with high visibility may benefit from monthly or quarterly cleaning. It depends on your location, weather exposure, and preferences.'
      },
      {
        question: 'Do you clean both inside and outside?',
        answer: 'Yes! Our standard service includes cleaning both sides of the windows, plus frames and sills. We also clean and replace fly screens. You can also book interior-only or exterior-only service if preferred.'
      },
      {
        question: 'What is purified water window cleaning?',
        answer: 'We use filtered, de-ionized water that\'s free from minerals and impurities. This leaves windows spot-free and streak-free without chemicals. It\'s eco-friendly, safe, and provides superior results that last longer than traditional methods.'
      },
      {
        question: 'Can you clean high or hard-to-reach windows?',
        answer: 'Yes, we have specialized equipment including water-fed poles (up to 4 stories), ladders, and safety equipment to access difficult windows safely. All high-access work is performed by trained technicians following strict safety protocols.'
      },
      {
        question: 'Do you clean windows in winter or rainy weather?',
        answer: 'We clean year-round! Light rain actually helps keep windows cleaner longer. We\'ll reschedule if conditions are unsafe (heavy rain, high winds), but light weather won\'t affect the quality of our work thanks to purified water technology.'
      }
    ]
  },

  'concrete-cleaning-hoppers-crossing': {
    title: 'Concrete Cleaning Hoppers Crossing',
    h1: 'Concrete & Driveway Cleaning Hoppers Crossing & Melbourne',
    subtitle: 'High-Pressure Cleaning | Driveway, Patio & Path Restoration',
    metaDescription: 'Professional concrete cleaning Hoppers Crossing. High-pressure cleaning for driveways, patios, paths. Remove oil stains, mold, grime. Call +61 493 519 401',
    heroImage: '/img/service/concrete-cleaning.jpg',
    whyChooseTitle: 'Professional Concrete & Driveway Cleaning',
    whyChooseContent: (
      <>
        <p>Restore your concrete surfaces to like-new condition with professional high-pressure cleaning from Niks Elite Cleaning. Serving Hoppers Crossing, Point Cook, Werribee, and Melbourne western suburbs, we specialize in concrete cleaning, driveway cleaning, and outdoor surface restoration.</p>
        <p>Over time, driveways, patios, pathways, and concrete surfaces accumulate dirt, oil stains, mold, mildew, and grime that regular hosing can't remove. Our commercial-grade pressure washing equipment blasts away years of buildup, revealing the clean concrete underneath and dramatically improving your property's curb appeal.</p>
        <p>We use hot water pressure washing for superior cleaning power, especially effective for oil stains and grease. Our experienced operators know the right pressure settings for different surfaces to ensure thorough cleaning without damaging your concrete, pavers, or stonework.</p>
        <p>Whether you're preparing to sell your property, hosting an event, or just want your outdoor areas looking their best, our concrete cleaning service delivers impressive results. We handle driveways, garage floors, patios, walkways, pool surrounds, retaining walls, and more across Hoppers Crossing and Melbourne's west.</p>
      </>
    ),
    includedTitle: 'What We Clean',
    includedItems: [
      'Concrete driveways and pathways',
      'Garage floors and workshops',
      'Patios and outdoor entertaining areas',
      'Pool surrounds and decking',
      'Retaining walls and fences',
      'Paved areas and pavers',
      'Rendered walls and facades',
      'Oil and grease stain removal',
      'Mold and mildew treatment',
      'Outdoor tiles and stonework',
      'Commercial carparks',
      'Warehouse floors'
    ],
    guarantee: null,
    areasContent: 'High-pressure concrete cleaning services available throughout:',
    serviceAreas: [
      'Hoppers Crossing VIC 3029',
      'Point Cook VIC 3030',
      'Werribee VIC 3030',
      'Truganina VIC 3029',
      'Williams Landing VIC 3027',
      'Sunshine VIC 3020',
      'Melbourne VIC 3004',
      'Parkville VIC 3052'
    ],
    faqs: [
      {
        question: 'Will pressure washing damage my concrete?',
        answer: 'Not when done correctly. Our experienced operators adjust pressure levels based on surface type and condition. We use appropriate PSI settings and techniques to clean effectively without causing damage to concrete, pavers, or tiles.'
      },
      {
        question: 'Can you remove oil stains from driveways?',
        answer: 'Yes! We use hot water pressure washing combined with specialized degreasers to remove even stubborn oil and grease stains. While some old, deep-set stains may lighten rather than disappear completely, most stains can be significantly improved or fully removed.'
      },
      {
        question: 'How long does concrete cleaning take?',
        answer: 'A typical residential driveway takes 1-3 hours depending on size and condition. Larger areas or heavily soiled surfaces may take longer. We\'ll provide an estimated timeframe when quoting your job.'
      },
      {
        question: 'Do you seal concrete after cleaning?',
        answer: 'Sealing is available as an additional service. After pressure cleaning, applying a concrete sealer helps protect the surface, prevents future staining, and makes maintenance easier. We can recommend whether sealing is beneficial for your surface.'
      },
      {
        question: 'Is pressure washing eco-friendly?',
        answer: 'We use water-efficient equipment and eco-friendly cleaning agents where needed. While pressure washing does use water, it\'s highly effective and typically uses less water than extended hosing. We also ensure proper wastewater management in accordance with local regulations.'
      }
    ]
  },

  'builders-clean-williams-landing': {
    title: 'Builders Clean Williams Landing',
    h1: 'Post Construction Cleaning Williams Landing & Melbourne',
    subtitle: 'Builder\'s Clean | Renovation Cleanup | New Home Handover Clean',
    metaDescription: 'Professional builders clean Williams Landing. Post construction cleaning, renovation cleanup. Remove dust, debris, paint. Handover ready. Call +61 493 519 401',
    heroImage: '/img/service/builders-clean.jpg',
    whyChooseTitle: 'Expert Post-Construction Cleaning',
    whyChooseContent: (
      <>
        <p>Transform your construction site into a pristine, handover-ready property with professional builder's cleaning from Niks Elite Cleaning. Serving Williams Landing, Point Cook, Werribee, and Melbourne western suburbs, we specialize in post-construction cleaning for new builds, renovations, and commercial construction projects.</p>
        <p>Construction and renovation create substantial dust, debris, and residue that requires specialized cleaning. Our experienced team knows exactly what's needed for a thorough post-construction clean - from removing construction dust and paint splatter to cleaning windows, fixtures, and every surface to make your property handover or move-in ready.</p>
        <p>We work with builders, contractors, renovators, and homeowners throughout Williams Landing and Melbourne's west. Our builder's clean service is thorough and systematic, ensuring every trace of construction is removed. We understand the importance of meeting handover deadlines and work efficiently to deliver your property on time.</p>
        <p>Our team is equipped with industrial-grade equipment including HEPA filter vacuums for fine dust removal, specialized chemicals for paint and adhesive removal, and all necessary tools for detailed cleaning. We're fully insured and experienced in construction site safety protocols.</p>
      </>
    ),
    includedTitle: 'Our Builder\'s Clean Includes',
    includedItems: [
      'Fine dust removal from all surfaces',
      'Window and glass cleaning (removing labels/stickers)',
      'Paint splatter and adhesive removal',
      'Kitchen appliance cleaning and detailing',
      'Bathroom fixture cleaning and polishing',
      'Light fitting and ceiling fan cleaning',
      'Skirting board and architrave wiping',
      'Cupboard and drawer cleaning (inside/out)',
      'Floor scrubbing and polishing',
      'Tile and grout cleaning',
      'Balcony/outdoor area cleanup',
      'Final inspection and touch-ups'
    ],
    guarantee: {
      title: 'Handover-Ready Guarantee',
      content: (
        <>
          <p><strong>We ensure your property is 100% handover ready or we'll re-clean any areas that don't meet standards.</strong></p>
          <p>Our builder's clean service follows a comprehensive checklist covering every area of the property. We understand the importance of meeting practical completion requirements and work to ensure your property passes inspection first time.</p>
          <p>If any areas don't meet your standards or your client's expectations, we'll return to address them promptly at no extra charge. We're committed to making your handover process smooth and stress-free.</p>
        </>
      )
    },
    areasContent: 'Post-construction cleaning services available throughout Melbourne\'s western growth corridor:',
    serviceAreas: [
      'Williams Landing VIC 3027',
      'Point Cook VIC 3030',
      'Werribee VIC 3030',
      'Truganina VIC 3029',
      'Hoppers Crossing VIC 3029',
      'Sunshine VIC 3020',
      'Melbourne VIC 3004',
      'Parkville VIC 3052'
    ],
    faqs: [
      {
        question: 'What\'s included in a builder\'s clean vs. final clean?',
        answer: 'A builder\'s clean (rough clean) removes construction debris, heavy dust, and prepares the site. A final clean (detailed clean) is more thorough - removing all dust, cleaning fixtures, windows, and making the property handover ready. We offer both services.'
      },
      {
        question: 'How long does a post-construction clean take?',
        answer: 'Timing depends on property size and construction extent. A typical 3-4 bedroom home takes 1-2 days for a thorough final clean. We can provide detailed quotes with timeframes based on your specific property.'
      },
      {
        question: 'Can you remove paint from windows and tiles?',
        answer: 'Yes! We\'re experienced in safely removing paint splatter, adhesive residue, concrete splatter, and construction stickers from windows, tiles, and fixtures using appropriate solvents and tools without causing damage.'
      },
      {
        question: 'Do you remove construction rubbish?',
        answer: 'We focus on cleaning rather than waste removal, but we can clear small debris and packaging. Large construction waste, materials, and rubble should be removed by the builder before our cleaning team arrives for best results.'
      },
      {
        question: 'Can you work with tight handover deadlines?',
        answer: 'Absolutely. We understand the time-sensitive nature of construction handovers and can mobilize teams quickly, work extended hours, or bring additional staff to meet your deadline. Just let us know your timeframe when booking.'
      }
    ]
  },

  'bnb-cleaning-parkville': {
    title: 'BNB Cleaning Parkville',
    h1: 'Airbnb & Short Stay Cleaning Services Parkville & Melbourne',
    subtitle: 'Fast Turnaround Cleaning | Linen Service | Professional Results',
    metaDescription: 'Professional Airbnb cleaning Parkville and Melbourne. Fast turnaround, linen service, 5-star ready. Perfect for short-stay properties. Call +61 493 519 401',
    heroImage: '/img/service/bnb-cleaning.jpg',
    whyChooseTitle: 'Professional Airbnb Cleaning in Parkville',
    whyChooseContent: (
      <>
        <p>Maximize your Airbnb ratings with professional cleaning from Niks Elite Cleaning. Serving Parkville, Melbourne CBD, Point Cook, and all western suburbs, we specialize in short-stay accommodation cleaning for Airbnb, Stayz, and other vacation rental properties.</p>
        <p>In the competitive short-stay market, cleanliness is everything. Poor reviews about cleanliness can destroy your bookings overnight. Our Airbnb cleaning service ensures your property is spotless, welcoming, and 5-star ready for every guest. We understand the tight turnaround times required between check-out and check-in.</p>
        <p>We offer same-day turnaround cleaning with flexible scheduling to match your booking calendar. Our team is experienced in short-stay cleaning standards - we know what guests expect and what hosts need to maintain excellent ratings. From studio apartments to multi-bedroom houses, we handle properties of all sizes.</p>
        <p>Optional linen service is available including washing, drying, and making beds with fresh linens. We can also restock bathroom amenities, check for damage or missing items, and provide photo confirmation when cleaning is complete. Our reliable service means you can focus on hosting while we handle the cleaning.</p>
      </>
    ),
    includedTitle: 'Our BNB Cleaning Service',
    includedItems: [
      'Complete property clean between guests',
      'Bedroom cleaning and bed making',
      'Bathroom sanitization and restocking',
      'Kitchen deep clean and dishwashing',
      'Living area dusting and vacuuming',
      'Floor mopping throughout',
      'Trash removal and bin cleaning',
      'Linen changing (with linen service)',
      'Towel replacement',
      'Amenity restocking',
      'Property inspection for damage',
      'Photo confirmation of completed clean'
    ],
    guarantee: {
      title: '5-Star Clean Guarantee',
      content: (
        <>
          <p><strong>We guarantee your property will be guest-ready and meet 5-star cleanliness standards.</strong></p>
          <p>Our Airbnb cleaning team is trained to the highest hospitality standards. We follow detailed checklists to ensure nothing is missed, and we understand the critical areas guests notice most. We inspect our own work before sending photo confirmation.</p>
          <p>If a guest identifies any cleanliness issues, we'll work with you to address the problem immediately. Maintaining your reputation is our priority.</p>
        </>
      )
    },
    areasContent: 'Short-stay property cleaning services throughout Melbourne:',
    serviceAreas: [
      'Parkville VIC 3052',
      'Melbourne CBD VIC 3004',
      'Point Cook VIC 3030',
      'Werribee VIC 3030',
      'Sunshine VIC 3020',
      'Truganina VIC 3029',
      'Hoppers Crossing VIC 3029',
      'Williams Landing VIC 3027'
    ],
    faqs: [
      {
        question: 'How quickly can you turn around a property?',
        answer: 'We offer same-day turnaround for most properties when booked in advance. Typical turnaround time is 2-4 hours depending on property size. For back-to-back bookings, we schedule cleaning immediately after check-out to ensure the property is ready before next check-in.'
      },
      {
        question: 'Do you provide linen and towels?',
        answer: 'We offer linen service where we collect, wash, dry, and return linens/towels, or we can work with your existing linen supplier. Alternatively, we can simply change and make beds using linens you provide in the property.'
      },
      {
        question: 'How do you coordinate with my bookings?',
        answer: 'We can integrate with your booking calendar or you can send us your cleaning schedule weekly/monthly. Many hosts give us access to their property management software for automatic scheduling. We\'re flexible and work with whatever system suits you best.'
      },
      {
        question: 'What if guests check out late?',
        answer: 'We build some buffer time into our schedules, but last-minute changes can be challenging. We communicate closely with hosts to adjust timing as needed. For regular clients, we often have backup availability to accommodate unexpected delays.'
      },
      {
        question: 'Do you provide keys and property access?',
        answer: 'Most hosts provide us with lockbox codes or smart lock access. We can also arrange key handover/return. All our cleaners are police-checked and trustworthy - many hosts have been working with us for years.'
      }
    ]
  }
};

// Helper function to get service by slug
export const getServiceBySlug = (slug) => {
  return servicesData[slug] || null;
};

// Export list of all service slugs
export const servicePages = Object.keys(servicesData);
